<p-card styleClass="card-container" header="Project Experience summary ">
  I have 13+ years of experience working in industry projects. i have experience in design and development 
  of web applications for retail , e-commerce , etc. using Node.js , Express , React , GraphQL.
  I am also having experience in  developing applications for healthcare devices, networking devices 
  using Java.<br/>
  Built microservices using Node.js / Express.js <br/>
  Developed micro-frontend using module fedaration. <br/>

</p-card>

<h3></h3>
<p></p>
<!-- <app-industry-projects></app-industry-projects> -->
<p-tabView>
  <p-tabPanel header="Industry Projects">
    <app-industry-projects></app-industry-projects>
  </p-tabPanel>
  <p-tabPanel header="POCs">
    <app-poc></app-poc>
  </p-tabPanel>
  <p-tabPanel header="Non-Industry/Freelance/support Projects">
    <app-freelance-projects></app-freelance-projects>
  </p-tabPanel>
</p-tabView>
